export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "logbooks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logbooks"])},
        "last_updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last updated"])}
      },
      "fr": {
        "logbooks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Journaux de bord"])},
        "last_updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dernière mise à jour"])}
      }
    }
  })
}